import { useEffect } from 'react';

import { useUserData } from '@givebacks/api/core';
import { useAtom } from 'jotai';
import { useSearchParams } from 'react-router-dom';

import { UserFeatureFlags } from '../flags.types';
import { useUserReleaseControl } from '../user/releaseControl';
import { previewAtom } from './userFlagsAtoms';

const useUserRelease = (feature: UserFeatureFlags) => {
  const { accessStatus, isLoading } = useUserReleaseControl({
    feature: feature,
  });
  return { isEnabled: !!accessStatus, isLoading };
};

const useUserInternalPreview = () => {
  const [search] = useSearchParams();
  const { data: user, isLoading } = useUserData();
  const [isEnabled, setIsPreview] = useAtom(previewAtom);

  useEffect(
    () => {
      if (user?.internal) {
        setIsPreview(isEnabled || search.get('preview') == 'true');
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user?.internal]
  );

  return { isEnabled, isLoading };
};

const useUserReleaseStudentFees = () => useUserRelease('user.studentFees');

// Backend feature flag and authentication check actually became a moot point since
// we're releasing the whole thing together and enabling for everyone.
/**
 * When we're ready to enable this for everyone, we can have this hook return
 * enabled always loading false and then clean up all feature flags.
 */
const useUserReleaseAccountPage = () => {
  return { isEnabled: true, isLoading: false };
};
/** Consolidated checkout feature flag. This is a temporary feature flag to allow developing the consolidated checkout experience. */
const useUserConsolidatedCheckout = () => useUserRelease('user.consolidatedCheckout');
export {
  useUserConsolidatedCheckout,
  useUserInternalPreview,
  useUserReleaseAccountPage,
  useUserReleaseStudentFees,
};
